let DefaultLabelValues = /*#__PURE__*/function (DefaultLabelValues) {
  DefaultLabelValues["SELECT_DATE"] = "Select a date";
  DefaultLabelValues["PREVIOUS_MONTH"] = "Previous month";
  DefaultLabelValues["NEXT_MONTH"] = "Next month";
  DefaultLabelValues["CLEAR_DATE"] = "Clear selected date";
  DefaultLabelValues["CANCEL"] = "Cancel";
  DefaultLabelValues["CONFIRM"] = "Confirm";
  return DefaultLabelValues;
}({});

export { DefaultLabelValues };
//# sourceMappingURL=labels.js.map
